module.exports = __webpack_public_path__ + "static/img/nodata.2b09ec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Activity/nodata.png
// module id = 486
// module chunks = 0